// extracted by mini-css-extract-plugin
export default {"CategoryStepAlert":"categoryStepAlert_CategoryStepAlert_a7WXM"};